import { Component, Input, OnInit } from "@angular/core";


import { MatDialog, MatSnackBar } from "@angular/material";
import { Estudo } from "../estudo/estudo";
import { EstudoService } from "../estudo/estudo.service";
import { ComparacaoDialog } from "./comparacao.dialog";

@Component({
  templateUrl: "./comparacao-button.component.html",
  selector: "comparacao-button"
})
export class ComparacaoButtonComponent implements OnInit{
  @Input()  estudo: Estudo;
  @Input()  mostrarTexto: boolean=true;

  public isLoading: boolean;
  public listaEstudos: Estudo[];

  constructor(public dialog: MatDialog, private estudoService: EstudoService, private mensagem: MatSnackBar) {

  }

  ngOnInit(){
    if(this.estudo && this.estudo.alunoRa){
     this.carregaListaEstudos();
    }else{
      this.mensagem.open("Erro ao carregar componente de comparação. Estudo vazio.", 'X', {duration: 5000});
    }
  }

  public carregaListaEstudos(){
    this.isLoading= true;
    let filtro: Estudo = new Estudo();
    filtro.alunoRa = this.estudo.alunoRa;

    this.estudoService.filtrar(filtro, null).subscribe(
      res=> {
        this.listaEstudos = res;
        this.isLoading= false;
      },
      error =>  this.erro(error)
    );
  }

  public abrirComparacao() {
    let dialogRef = this.dialog.open(ComparacaoDialog, {
      width: "1680px",
      height: "900px",
      data: this.listaEstudos
    });
    let resultado: any;
    dialogRef.afterClosed().subscribe(result => {});
  }

  private erro(erro: string): void{
    this.mensagem.open(erro, 'X', {duration: 5000});
    this.isLoading= false;
  }

}
